import { GET_POSTS } from "constants/posts";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_POSTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
